<template>
    <div :class="{ 'transform -translate-y-full' : !showModal }" class="fixed overflow-x-hidden overflow-y-auto inset-0 flex justify-center items-center z-50 bg-gray-800 bg-opacity-75 transition ease-in-out duration-200">
        <div class="relative w-full max-w-md max-h-full">
            <div class="shadow-lg bg-white border-2 border-black border-solid rounded-md p-3">
                <div class="flex items-start justify-between border-b pb-3 rounded-t dark:border-gray-600">
                    <h3 class="flex gap-2 items-center text-xl font-semibold text-gray-900 dark:text-white">
                        <div class="bg-blue-500 w-10 h-10 flex items-center justify-center rounded-full text-white">
                            <SvgIcons iconname="exclamation-triangle"></SvgIcons>
                        </div>
                        System Information
                    </h3>
                    <button @click="$emit('onClose')" class="bg-red-500 w-8 h-8 flex items-center justify-center rounded-full">
                        <SvgIcons iconname="x-mark"></SvgIcons>
                    </button>
                </div>
                <div class="w-full items-center p-3 gap-5">
                    <span class="font-semibold">{{ msgmsg }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SvgIcons from './SvgIcons.vue';

export default {
    components:{
        SvgIcons
    },
    props: {
        showModal: Boolean,
        msgmsg: String
    },
}
</script>